import React from 'react';
import { Fab, Badge, Box, useTheme } from '@mui/material';
import { motion, AnimatePresence } from 'framer-motion';
import { colors } from '../../utils/designSystem';

interface ChatFabProps {
  onClick: () => void;
  unreadCount?: number;
}

const MotionFab = motion.create(Fab);

const ChatFab: React.FC<ChatFabProps> = ({ onClick, unreadCount = 0 }) => {
  const theme = useTheme();

  return (
    <AnimatePresence>
      <MotionFab
        initial={{ scale: 0, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        exit={{ scale: 0, opacity: 0 }}
        transition={{ type: 'spring', stiffness: 260, damping: 20 }}
        whileHover={{ scale: 1.08 }}
        whileTap={{ scale: 0.95 }}
        onClick={onClick}
        aria-label="Open AI chat"
        sx={{
          position: 'fixed',
          bottom: { xs: 16, md: 24 },
          right: { xs: 16, md: 24 },
          zIndex: 1250,
          width: 56,
          height: 56,
          bgcolor: theme.palette.mode === 'dark' ? colors.primary[600] : colors.gray[900],
          color: 'white',
          boxShadow: '0 4px 20px rgba(0,0,0,0.25)',
          '&:hover': {
            bgcolor: theme.palette.mode === 'dark' ? colors.primary[700] : colors.gray[800],
          },
        }}
      >
        <Badge
          badgeContent={unreadCount}
          color="error"
          max={9}
          sx={{
            '& .MuiBadge-badge': {
              top: -4,
              right: -4,
              fontSize: '0.65rem',
              minWidth: 18,
              height: 18,
            },
          }}
        >
          <Box
            component="img"
            src="/logo192-dark.png"
            alt="Valuate AI"
            sx={{ width: 28, height: 28, objectFit: 'contain' }}
          />
        </Badge>
      </MotionFab>
    </AnimatePresence>
  );
};

export default ChatFab;
